import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IElearningTopicCategoryTranslationVm } from '../elearning-topic-category-translation-vm.model';
import { IOperatorElearningTopicCategoryTranslationIm } from '../operator-elearning-topic-category-translation-im.model';
import { IOperatorElearningTopicCategoryTranslationUm } from '../operator-elearning-topic-category-translation-um.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicCategoryTranslationService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopicCategoryTranslation`;
  }
  post(translationIm: IOperatorElearningTopicCategoryTranslationIm): Observable<IElearningTopicCategoryTranslationVm> {
    const headers = this.createHeaders();
    return this.http.post<IElearningTopicCategoryTranslationVm>(this.baseUrl, translationIm, { headers });
  }
  put(translationUm: IOperatorElearningTopicCategoryTranslationUm): Observable<IElearningTopicCategoryTranslationVm> {
    const headers = this.createHeaders();
    return this.http.put<IElearningTopicCategoryTranslationVm>(this.baseUrl, translationUm, { headers });
  }
  delete(id: number): Observable<any> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (id !== undefined && id !== null) {
      params = params.set('id', id.toString());
    }
    return this.http.delete<any>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
